
export default function PerchéHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/08ec730ca599a4c2434ee87933063c78.jpg"
          alt="Perché Valorizzare il Brand"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="text-center mb-20">
          {/* Badge */}
          <div className="inline-flex items-center px-6 py-3 bg-white/95 backdrop-blur-sm border border-[#E879F9]/30 rounded-full text-sm font-semibold text-slate-800 mb-8 shadow-xl">
            <i className="ri-lightbulb-flash-line text-[#E879F9] mr-2 text-lg"></i>
            Scopri i Vantaggi della Valorizzazione
          </div>
          
          {/* Main Title */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight drop-shadow-2xl">
            Perché Valorizzare
            <span className="block mt-2 bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent">
              il Tuo Brand?
            </span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/95 max-w-4xl mx-auto mb-12 leading-relaxed font-light drop-shadow-lg">
            Trasforma il tuo brand in un asset strategico misurabile e valorizzabile. 
            Scopri come la valorizzazione professionale può generare vantaggi competitivi concreti 
            e opportunità di crescita straordinarie.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/contatti')}
              className="group px-8 py-4 bg-gradient-to-r from-[#E879F9] to-[#22C55E] text-white rounded-full font-semibold text-lg shadow-2xl hover:shadow-[#E879F9]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Richiedi Consulenza Gratuita
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
            </button>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/case-study')}
              className="px-8 py-4 bg-white/95 backdrop-blur-sm text-slate-800 rounded-full font-semibold text-lg border-2 border-white/50 hover:border-[#E879F9] hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-xl"
            >
              Vedi i Risultati
              <i className="ri-bar-chart-line ml-2"></i>
            </button>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 border border-white/50 shadow-2xl hover:shadow-[#E879F9]/30 transition-all duration-300 hover:-translate-y-2">
              <div className="text-5xl font-bold bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent mb-3">
                +150%
              </div>
              <div className="text-slate-700 font-medium text-lg">
                Incremento Medio del Valore
              </div>
            </div>
            
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 border border-white/50 shadow-2xl hover:shadow-[#22C55E]/30 transition-all duration-300 hover:-translate-y-2">
              <div className="text-5xl font-bold bg-gradient-to-r from-[#22C55E] to-[#E879F9] bg-clip-text text-transparent mb-3">
                500+
              </div>
              <div className="text-slate-700 font-medium text-lg">
                Aziende Valorizzate
              </div>
            </div>
            
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 border border-white/50 shadow-2xl hover:shadow-[#E879F9]/30 transition-all duration-300 hover:-translate-y-2">
              <div className="text-5xl font-bold bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent mb-3">
                98%
              </div>
              <div className="text-slate-700 font-medium text-lg">
                Soddisfazione Clienti
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#E879F9]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#22C55E]/10 rounded-full blur-3xl"></div>
    </section>
  );
}
